import React from 'react';
import styles from './style.js';
// import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';

import { Swiper, SwiperSlide } from "swiper/react";
import { MpingClick } from '../../../utils/tool.js';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import "swiper/components/pagination/pagination.min.css"
import "swiper/components/navigation/navigation.min.css"
import './index.css';

SwiperCore.use([Autoplay, Pagination]);

let timer = null;
let exposedIndex = [];

const BannerSwiper = (props) => {
  const onSlideChange = (swiper) => {
    if (window.expLogJSON) {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        let activeIndex = Math.max(swiper.activeIndex - 1, 0);
        if (activeIndex >= props.bannerList.length) {
          activeIndex = activeIndex - props.bannerList.length;
        }
        // 避免重复曝光
        if (exposedIndex.includes(activeIndex)) return
        const activeItem = props.bannerList[activeIndex] || {};
        const params = {
          'action_source': '' + props.publishSource,
          'venderid': '' + props.vendorId,
          'frame': '' + activeIndex,
          'activity_url': activeItem.linkUrl
        };
        MpingClick('MAuction_NewShop_banner_expo', '', '', 'MAuction_NewShop', params)
        exposedIndex.push(activeIndex)
      }, 500)
    }
  }

  const handleClickSwiper = (item, index) => {
    const params = {
      'action_source': '' + props.publishSource,
      'venderid': '' + props.vendorId,
      'frame': '' + index,
      'activity_url': item.linkUrl
    };

    MpingClick('MAuction_NewShop_banner', '', '', 'MAuction_NewShop', params)
    window.location.href = item.linkUrl;
  }



  return (
    <div style={styles.bannerWrapper}>
      <Swiper
        modules={[Autoplay, Pagination]}
        style={styles.bannerSwiper}
        spaceBetween={10}
        slidesPerView={1}
        autoplay={props.bannerList && props.bannerList.length > 1 ? {
          disableOnInteraction: false, 
          delay: 3000,
        } : false}     
        loop={props.bannerList && props.bannerList.length > 1 ? true : false}
        pagination={{ 
          clickable: true,  
          // bulletClass: `swiper-pagination-bullet ${styles.bullet}`,
          // bulletActiveClass: styles.bulletActive
      }}
        onSlideChange={onSlideChange}
        onInit={onSlideChange}
        // onSwiper={(swiper) => console.log(swiper)}
      >
        {props.bannerList && props.bannerList.map((item, index) => {
          return  (
            <SwiperSlide key={index} onClick={() => handleClickSwiper(item, index)}>
              <img src={item.imgUrl} alt="" style={styles.swiperItem}  />
          </SwiperSlide>
          )
        })}


      </Swiper>
      <div ></div>
    </div>

  )

}

export default BannerSwiper;